// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditions":"_ed2adce"};